(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zippi_nutrition_snippet"] && !Shopify.designMode) return;
  try {
    class ZippiNutrition extends HTMLElement {
    constructor() {
      super();
      this.toggles = this.querySelectorAll('[data-zippi-toggle]');
      this.values = this.querySelectorAll('[data-zippi-value]');
      this.toggles.forEach((btn) =>
        btn.addEventListener('click', () => this.select(btn.dataset.zippiToggle))
      );
    }

    select(dataset) {
      this.toggles.forEach((btn) => {
        const active = btn.dataset.zippiToggle === dataset;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      this.values.forEach((el) => {
        const next = dataset === 'int' ? el.dataset.int : el.dataset.reg;
        el.textContent = next || el.dataset.reg;
      });
    }
  }

  customElements.define('zippi-nutrition', ZippiNutrition);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zippi_plp_header"] && !Shopify.designMode) return;
  try {
    class ZippiProductPanel extends HTMLElement {
    constructor() {
      super();
      this.panel = this.querySelector('.zippi_plp__panel');
      this.input = this.querySelector('[data-zippi-input]');
      this.reset = this.querySelector('[data-zippi-reset]');
      this.results = this.querySelector('[data-zippi-results]');
      this.noResults = this.querySelector('[data-zippi-noresults]');
      this.detailWrap = this.querySelector('[data-zippi-detail-wrap]');
      this.stepsClose = this.querySelector('.zippi_plp__view--steps [data-zippi-close]');
      this.opener = null;

      this.querySelectorAll('[data-zippi-open]').forEach((btn) =>
        btn.addEventListener('click', () => this.open(btn))
      );
      this.querySelectorAll('[data-zippi-close]').forEach((btn) =>
        btn.addEventListener('click', () => this.close())
      );
      this.querySelector('[data-zippi-overlay]').addEventListener('click', () => this.close());
      this.querySelector('[data-zippi-back]').addEventListener('click', () => this.closeDetail());

      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        if (this.hasAttribute('steps-open')) return this.close();
        this.hasAttribute('detail-open') ? this.closeDetail() : this.close();
      });

      this.input.addEventListener('input', () => this.filter());
      this.reset.addEventListener('click', () => {
        this.input.value = '';
        this.filter();
        this.input.focus();
      });

      this.querySelectorAll('[data-zippi-item]').forEach((item) =>
        item.addEventListener('click', () => this.openDetail(item.dataset.handle))
      );
    }

    normalize(value) {
      return value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
    }

    filter() {
      const query = this.normalize(this.input.value);
      this.reset.classList.toggle('hidden', query === '');
      let visible = 0;
      this.results.querySelectorAll('[data-zippi-name]').forEach((li) => {
        const match = query === '' || this.normalize(li.dataset.zippiName).includes(query);
        li.hidden = !match;
        if (match) visible += 1;
      });
      this.noResults.classList.toggle('hidden', visible !== 0);
    }

    open(opener) {
      this.opener = opener;
      const mode = opener.dataset.zippiOpen || 'list';
      this.removeAttribute('detail-open');
      this.toggleAttribute('steps-open', mode === 'steps');
      this.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
      opener.setAttribute('aria-expanded', 'true');
      trapFocus(this.panel, mode === 'steps' ? this.stepsClose : this.input);
    }

    close() {
      this.removeAttribute('open');
      this.removeAttribute('detail-open');
      this.removeAttribute('steps-open');
      document.body.classList.remove('overflow-hidden');
      if (this.opener) this.opener.setAttribute('aria-expanded', 'false');
      removeTrapFocus(this.opener);
    }

    openDetail(handle) {
      this.detailWrap.querySelectorAll('[data-zippi-detail]').forEach((block) => {
        block.hidden = block.dataset.zippiDetail !== handle;
      });
      this.detailWrap.scrollTop = 0;
      this.removeAttribute('steps-open');
      this.setAttribute('detail-open', '');
      trapFocus(this.panel, this.querySelector('[data-zippi-back]'));
    }

    closeDetail() {
      this.removeAttribute('detail-open');
      trapFocus(this.panel, this.input);
    }
  }

  customElements.define('zippi-product-panel', ZippiProductPanel);
  } catch(e) { console.error(e); }
})();

})();
